(function(){
  const selectors = {
    categoryMenuWrapper: '.collection__category-menu-wrapper',
    categoryMenuItems: '.collection__category-menu span',
    collectionProductGrid: '[data-section-type="collection"]',
  }

  async function fetchCollectionSection(url, sectionId) {
    try {
      const response = await fetch(`${url}?section_id=${sectionId}`);
      const data = await response.text();
      const parser = new DOMParser();
      const dataHTML = parser.parseFromString(data, 'text/html');
      const collectionSection = dataHTML.querySelector(selectors.collectionProductGrid);
      const collectionProductGrid = document.querySelector(selectors.collectionProductGrid);
      const event = new CustomEvent('collection-category:updated', { detail: { collectionSection } });

      history.pushState({}, '', url);
      collectionProductGrid.parentElement.replaceChild(collectionSection, collectionProductGrid);
      document.dispatchEvent(event);
      initListeners();
    } catch (error) {
      console.log('Error when fetching collection section:', error)
    }
  }

  function initListeners() {
    const categoryMenuItems = document.querySelectorAll(selectors.categoryMenuItems);

    categoryMenuItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        const category = e.currentTarget;
        const categoryUrl = category.dataset.url;
        const sectionId = category.closest(selectors.categoryMenuWrapper).dataset.sectionId;

        fetchCollectionSection(categoryUrl, sectionId)
      })
    })
  }

  initListeners();
})();